import { useParams } from 'react-router-dom';

function User() {
  const { id } = useParams();
  return <div className="wrap">{id}</div>;
}

export default User;
